import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Define a type for the slice state
export interface EmailTemplateTableStateState {
  TableState: string
};

// Define the initial state using that type
const initialState: EmailTemplateTableStateState = {
  TableState: JSON.stringify({sorting:{sortModel:[{ field:'templateName',sort:'asc'}]}})
};

export const EmailTemplateTableStateSlice = createSlice({
  name: 'emailTemplateTableState',
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateEmailTemplateGridState: (state, action: PayloadAction<string | null>) => {
        state.TableState = action?.payload ?? initialState.TableState;
    }
  }
});

export const { updateEmailTemplateGridState } = EmailTemplateTableStateSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const emailTemplateTableState = (state: RootState) => state;
export default EmailTemplateTableStateSlice.reducer;